/**
 * Lay buttons / product links use classes like .laybutton1.laybutton — animating inner
 * .word spans looks wrong (outline/bg on the anchor). We animate the whole control instead.
 */
export const LAYBUTTON_ANIMATION_ROOT_SELECTOR =
	'a[class*="laybutton"], button[class*="laybutton"], span[class*="laybutton"]'

/**
 * Ordered list of elements to use for word-level animations (masked_words, fade_words).
 * Words inside a laybutton parent are collapsed to that parent (one stagger step per button).
 *
 * @param {HTMLElement} root  Usually .lay-text-animation
 * @returns {HTMLElement[]}
 */
export function getWordLevelAnimationTargets(root) {
	const words = Array.from(root.querySelectorAll('.lay-text-line .word'))
	const targets = []
	const seenBtn = new WeakSet()

	for (let i = 0; i < words.length; i++) {
		const word = words[i]
		const btn = word.closest(LAYBUTTON_ANIMATION_ROOT_SELECTOR)
		if (btn && root.contains(btn)) {
			if (seenBtn.has(btn)) {
				continue
			}
			seenBtn.add(btn)
			targets.push(btn)
		} else {
			targets.push(word)
		}
	}
	return targets
}

/**
 * Same as getWordLevelAnimationTargets, but for character-level animations
 * (masked_characters, typewriter, typewriter_fade). Characters inside a laybutton
 * parent are collapsed to that parent so the button reveals as one unit (its
 * background/border can't be sensibly animated per-char) at the stagger position
 * of its first inner char.
 *
 * @param {HTMLElement} root  Usually .lay-text-animation
 * @returns {HTMLElement[]}
 */
export function getCharacterLevelAnimationTargets(root) {
	const characters = Array.from(root.querySelectorAll('.lay-text-line .char'))
	const targets = []
	const seenBtn = new WeakSet()

	for (let i = 0; i < characters.length; i++) {
		const ch = characters[i]
		const btn = ch.closest(LAYBUTTON_ANIMATION_ROOT_SELECTOR)
		if (btn && root.contains(btn)) {
			if (seenBtn.has(btn)) {
				continue
			}
			seenBtn.add(btn)
			targets.push(btn)
		} else {
			targets.push(ch)
		}
	}
	return targets
}
